/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect } from "react";
import Filter from "./../../components/Filter";
import Graph from "./Graph";
import locationData from "../../assets/locations.json";
import fetchHelper from "../../services/fetchHelper";
import { ISO, assignerHubOptions } from "../../constants/UsersGraphConstants";

const UsersGraph = () => {
  const [filter, setFilter] = useState({});
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeFilter = (data) => {
    setFilter({ ...data, temp: new Date().getTime() });
  };

  useEffect(() => {
    fetchLocation();
  }, []);

  const locOptions = [];
  locationData.forEach((item) => {
    locOptions.push({ label: item.name, value: item.id });
  });

  const fetchLocation = async () => {
    try {
      let url = "/patientmanagement/rest/location/serviceReport";
      const res = await fetchHelper.get({ url });
      setLocations(res.map((i) => ({ value: i.id, label: i.name })));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div style={{ display: "flex", flex: 1 }}>
      <div style={{ display: "flex", width: 350 }}>
        {locations.length > 0 ? (
          <Filter
            onChange={onChangeFilter}
            loading={loading}
            fields={[
              { type: "line" },
              {
                type: "multiSelect",
                key: "interrogationStatus",
                whereKey: "interrogationStatus",
                label: "Report Status",
                options: ISO,
                initialSelected: ISO,
                maxSelect: 15,
              },
              {
                type: "multiSelect",
                key: "location",
                whereKey: "location.id",
                label: "Location",
                options: locations,
                initialSelected: locations,
                maxSelect: 5,
                forceHasSelectAll: true,
              },
              { type: "dateRange", key: "dateRange", initialEnd: "12/1/2020", initialStart: "6/1/2020" },
              {
                type: "multiSelect",
                key: "assigner.hub",
                whereKey: "assigner.hub",
                label: "Assigner HUB",
                options: assignerHubOptions,
                maxSelect: 2,
                initialSelected: [{ value: "HubA" }],
                forceHasSelectAll: false,
              },
            ]}
          />
        ) : null}
      </div>
      <div style={{ display: "flex", flex: 1 }}>
        <Graph {...filter} onLoadingChange={(v) => setLoading(v)} />
      </div>
    </div>
  );
};

export default UsersGraph;
